<template>
  <el-table
    :data="state.tableData"
    v-loading="!Array.isArray(state.tableData)"
    element-loading-background="rgba(0, 0, 0, 0.2)"
  >
    <el-table-column label="#" type="index"></el-table-column>
    <el-table-column label="状态" width="80" align="center">
      <template #default="{ row }">
        <template v-if="isZuHeShangPin(row)">
          <el-tag v-if="isOrderPaid" type="success" size="small">已出票</el-tag>
          <el-tag v-else type="warning" size="small">待出票</el-tag>
        </template>
        <template v-else>
          {{ $tab_StatusFormat(row, null, row.Zt) }}
        </template>
      </template>
    </el-table-column>
    <el-table-column label="出票状态" width="100" align="center">
      <template #default="{ row }">
        <el-tag
          v-if="isZuHeShangPin(row) && isOrderPaid"
          type="success"
          size="small"
        >已出票(自动)</el-tag>
        <el-tag
          v-else-if="isZuHeShangPin(row)"
          type="warning"
          size="small"
        >待出票</el-tag>
        <text v-else>-</text>
      </template>
    </el-table-column>
    <el-table-column label="OTA/核验" width="140" align="center">
      <template #default="{ row }">
        <template v-if="row.OTAStatus != null">
          <el-tooltip
            v-if="row.OTATicketNo"
            :content="row.OTATicketNo"
            placement="top"
          >
            <el-tag
              :type="otaTagType(row.OTAStatus)"
              size="small"
            >OTA: {{ otaStatusText(row.OTAStatus) }}</el-tag>
          </el-tooltip>
          <el-tag
            v-else
            :type="otaTagType(row.OTAStatus)"
            size="small"
          >OTA: {{ otaStatusText(row.OTAStatus) }}</el-tag>
        </template>
        <template v-else-if="row.HyrXm">
          <text>{{ row.HyrXm }}</text>
        </template>
        <text v-else>-</text>
      </template>
    </el-table-column>
    <el-table-column
      prop="Syrq"
      label="使用日期"
      :formatter="$tab_TextFormat"
      width="110"
    ></el-table-column>
    <el-table-column
      prop="SpMc"
      label="商品名称"
      :formatter="$tab_TextFormat"
    ></el-table-column>
    <el-table-column
      prop="SpPlMc"
      label="商品品类"
      :formatter="$tab_TextFormat"
    ></el-table-column>
    <el-table-column
      prop="SpTcMc"
      label="套餐名称"
      :formatter="$tab_TextFormat"
    ></el-table-column>
    <el-table-column prop="Sl" label="数量"></el-table-column>
    <el-table-column label="销售价">
      <template #default="{ row }">
        <text>{{
          $priceFormat(row.Xsdj) +
          " * " +
          row.Sl +
          " = " +
          $priceFormat(row.Xszj)
        }}</text>
      </template>
    </el-table-column>
    <el-table-column
      label="已收/未收"
      :formatter="
        (row) =>
          $tab_GroupFormat($priceFormat(row.Ysje), $priceFormat(row.Khqk))
      "
    ></el-table-column>
    <el-table-column label="结算价">
      <template #default="{ row }">
        <text>{{
          $priceFormat(row.Jsdj) +
          " * " +
          row.Sl +
          " = " +
          $priceFormat(row.Jszj)
        }}</text>
      </template>
    </el-table-column>
    <el-table-column
      label="已付/未付"
      :formatter="
        (row) =>
          $tab_GroupFormat($priceFormat(row.Yfje), $priceFormat(row.Jsqk))
      "
    ></el-table-column>
    <el-table-column
      prop="Fl"
      label="返利"
      :formatter="$tab_MoneyFormat"
    ></el-table-column>
  </el-table>
</template>

<script>
import { computed, onMounted, reactive } from "vue";
import { shangpindingdan_getmx } from "@/http/api";
export default {
  props: {
    ddId: Number,
    orderZt: Object,
  },
  setup(props) {
    const state = reactive({});

    // 判断是否为组合商品（包含组合、套餐等自动出票类型）
    const isZuHeShangPin = (row) => {
      return row?.SpPlMc && (row.SpPlMc.includes("组合") || row.SpPlMc.includes("套餐"));
    };

    // 判断订单是否已支付 (已支付: Key >= 2, 已取消: Key == 4)
    const isOrderPaid = computed(() => {
      return props.orderZt?.Key >= 2 && props.orderZt?.Key != 4;
    });

    // OTA 状态文本
    const otaStatusText = (status) => {
      const map = {
        0: "成功",
        100002: "部分使用",
        100003: "全部使用",
        100004: "已作废",
      };
      return map[status] || status;
    };

    // OTA 状态 Tag 颜色
    const otaTagType = (status) => {
      if (status == 0) return "success";
      if (status == 100002 || status == 100003) return "primary";
      if (status == 100004) return "danger";
      return "info";
    };

    onMounted(() => {
      shangpindingdan_getmx(props.ddId).then((res) => {
        if (res.status == 200) state.tableData = res.data;
      });
    });
    return {
      state,
      isZuHeShangPin,
      isOrderPaid,
      otaStatusText,
      otaTagType,
    };
  },
};
</script>
<style scoped></style>
